import { render, staticRenderFns } from "./duplicateCertificate.vue?vue&type=template&id=6d8f1376&scoped=true&"
import script from "./duplicateCertificate.vue?vue&type=script&lang=js&"
export * from "./duplicateCertificate.vue?vue&type=script&lang=js&"
import style0 from "./duplicateCertificate.vue?vue&type=style&index=0&id=6d8f1376&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f1376",
  null
  
)

export default component.exports